import { render, staticRenderFns } from "./ModaLocalProibidoSubGrupoProduto.vue?vue&type=template&id=312cf40d&scoped=true"
import script from "./ModaLocalProibidoSubGrupoProduto.vue?vue&type=script&lang=js"
export * from "./ModaLocalProibidoSubGrupoProduto.vue?vue&type=script&lang=js"
import style0 from "./ModaLocalProibidoSubGrupoProduto.vue?vue&type=style&index=0&id=312cf40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312cf40d",
  null
  
)

export default component.exports